export let RequestAccountantAccess = /*#__PURE__*/function (RequestAccountantAccess) {
  RequestAccountantAccess["None"] = "none";
  RequestAccountantAccess["Mandatory"] = "mandatory";
  RequestAccountantAccess["Optional"] = "optional";
  return RequestAccountantAccess;
}({});